import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"; // Fixed import
import images from "../constants/images";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation(); // Get current route
  const isActive = (path) => location.pathname === path;

  useEffect(() => {
    const handleScroll = () => {
      const threshold = window.innerHeight * 0.3;
      setIsSticky(window.scrollY > threshold);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <>
      <nav
        className={`bg-gray-900 text-white p-8 mr-6 ml-6 backdrop-blur-0 transition-all duration-300 ${
          isSticky ? "fixed top-0 left-0 right-0 z-50 shadow-xl" : "relative"
        }`}
      >
        <div className="max-w-6xl mx-auto">
          {/* Top Row - Logo & Cart */}
          <div className="flex justify-between items-center w-full">
            {/* Logo - Left */}
            <Link
              to="/"
              className="flex items-center space-x-4 text-2xl font-bold"
            >
              <img
                src={images.Zablogomd}
                className="w-28 h-24 object-contain"
                alt="Logo"
              />
              <span className="whitespace-nowrap hidden md:inline">
                Zab Tours and Travels
              </span>
            </Link>

            {/* Right Section - Mobile Menu & Cart */}
            <div className="flex items-center space-x-4">
              {/* Mobile Menu Button */}
              <button
                className="md:hidden p-2"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Desktop Menu - Centered below Logo */}
          <div className="hidden md:flex justify-center mt-4 w-full">
            <div className="space-x-10 bg-yellow-500 px-6 py-2 w-full">
              <Link
                to="/"
                className={`px-4 py-2 transition-all duration-300 ${
                  isActive("/")
                    ? "font-extrabold text-blue-600"
                    : "text-white hover:text-blue-400"
                }`}
              >
                Home
              </Link>
              <Link
                to="/services"
                className={`px-4 py-2 transition-all duration-300 ${
                  isActive("/services")
                    ? "font-extrabold text-blue-600"
                    : "text-white hover:text-blue-400"
                }`}
              >
                Services
              </Link>
              <Link
                to="/about"
                className={`px-4 py-2 transition-all duration-300 ${
                  isActive("/about")
                    ? "font-extrabold text-blue-600"
                    : "text-white hover:text-blue-400"
                }`}
              >
                About
              </Link>
              <Link
                to="/contactus"
                className={`px-4 py-2 transition-all duration-300 ${
                  isActive("/contactus")
                    ? "font-extrabold text-blue-600"
                    : "text-white hover:text-blue-400"
                }`}
              >
                Contact
              </Link>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 space-y-4">
            <Link to="/" className="block px-4 py-2 hover:bg-gray-800">
              Home
            </Link>
            <Link to="/services" className="block px-4 py-2 hover:bg-gray-800">
              Services
            </Link>
            <Link to="/about" className="block px-4 py-2 hover:bg-gray-800">
              About
            </Link>
            <Link to="/contactus" className="block px-4 py-2 hover:bg-gray-800">
              Contact
            </Link>
          </div>
        )}
      </nav>
      {isSticky && <div className="h-16"></div>}
    </>
  );
};

export default Navbar;
